// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4.21995 6.22427C8.14187 2.30235 14.2885 1.96104 18.5976 5.20031H16.4981V7.20031H21.4834L21.4861 1.50132L19.4861 1.49996L19.4849 3.37211C14.4112 -0.210199 7.34668 0.269114 2.80574 4.81005L2.09863 5.51716L3.51285 6.93137L4.21995 6.22427Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0008 4.81006C10.7527 4.81006 9.74083 5.8219 9.74083 7.07006V15.1337L7.0643 14.6049C6.31896 14.4577 5.5583 14.7739 5.13705 15.4062L4.1875 16.8314L8.48582 22.4227C9.00764 23.1014 9.81522 23.4993 10.6714 23.4993H17.7569C18.9437 23.4993 19.9973 22.7397 20.3723 21.6138L22.1548 16.2632C22.567 15.0257 22.0555 13.6687 20.929 13.0111L17.3043 10.8954C16.8826 10.6492 16.403 10.5195 15.9146 10.5195H14.2608V7.07006C14.2608 5.8219 13.249 4.81006 12.0008 4.81006Z"}}]};

const GestureRightSlipFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'gesture-right-slip-filled',
    ref,
    icon: element,
  },
));

GestureRightSlipFilledIcon.displayName = 'GestureRightSlipFilledIcon';

export default GestureRightSlipFilledIcon;
